import { movePointsConstants } from './move-points.constants'
import { MOVEFLEX_NUMBERS } from '../../../../constants'

const initialState = {
	isMoving: false,
	sender: { name: 'MOVEFLEX', id: MOVEFLEX_NUMBERS.MOVEFLEX, points: '' },
	receiver: { name: '', id: '', points: '' },
	options: [],
	pointsToBeMoved: 0
}

function movePointsReducer(state = initialState, { type, payload }) {
	switch (type) {
		case movePointsConstants.MOVE_POINTS:
			return {
				...state,
				isMoving: true
			}

		case movePointsConstants.POINTS_MOVED:
			return {
				...state,
				isMoving: false,
				errors: payload
			}

		case movePointsConstants.UPDATE_SENDER:
			return {
				...state,
				sender: payload
			}

		case movePointsConstants.UPDATE_POINTS_TO_BE_MOVED:
			return {
				...state,
				pointsToBeMoved: payload
			}

		case movePointsConstants.UPDATE_RECEIVER:
			return {
				...state,
				receiver: payload
			}

		case movePointsConstants.ADD_OPTIONS:
			return {
				...state,
				options: state.options.concat(payload).$unique()
			}

		default:
			return state
	}
}

export { movePointsReducer as Reducer }
